const CME_ROR_Status = {
    "Not Started": 1,
    "Requires Additional ROR": 2,
    "In Progress":3,
    "Completed":4
};

export default CME_ROR_Status;